var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_Settings",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.5,
    height: 18,
    viewBox: "0 0 17.5 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M618.111,13.278a7.355,7.355,0,0,0,.056-.877,5.543,5.543,0,0,0-.068-.878l1.9-1.485a.465.465,0,0,0,.113-.574l-1.8-3.116a.457.457,0,0,0-.551-.2l-2.239.9A6.592,6.592,0,0,0,614,6.168l-.337-2.385a.449.449,0,0,0-.45-.383h-3.6a.438.438,0,0,0-.439.383l-.338,2.385a6.765,6.765,0,0,0-1.519.878l-2.238-.9a.445.445,0,0,0-.551.2l-1.8,3.116a.436.436,0,0,0,.113.574l1.9,1.485a5.307,5.307,0,0,0-.011,1.755l-1.9,1.485a.465.465,0,0,0-.112.574l1.8,3.116a.458.458,0,0,0,.551.2l2.239-.9a6.588,6.588,0,0,0,1.519.878l.338,2.385a.458.458,0,0,0,.45.382h3.6a.43.43,0,0,0,.439-.382l.338-2.385a6.768,6.768,0,0,0,1.519-.878l2.239.9a.445.445,0,0,0,.551-.2l1.8-3.116a.436.436,0,0,0-.113-.574Zm-6.694,2.5a3.375,3.375,0,1,1,3.375-3.375A3.385,3.385,0,0,1,611.417,15.775Z",
    transform: "translate(-602.667 -3.4)",
    fill: "#ed8154"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettings);
export default __webpack_public_path__ + "static/media/Icon_Settings.daa7a145b2738edbee5cee67e1132dbd.svg";
export { ForwardRef as ReactComponent };